import Vue from 'vue'

import Radio from '@/components/Radio/Radio.vue'
import RadioGroup from '@/components/RadioGroup/RadioGroup.vue'
import SearchInput from '@/components/SearchInput/SearchInput.vue'
import DataLoader from '@/components/DataLoader/Loader.vue'
import RecGameItem from '@/views/index/subComp/RecGameItem.vue'
import SearchGameItem from '@/views/landpage/subComp/SearchGameItem.vue'
import Page from '@/components/Page.vue'
import ListStatus from '@/components/Status/index.vue'

// 以插件的方式注册组件
import Toast from '@/components/Toast'
import NormalDialog from '@/components/Dialog/NormalDialog'
import LoginDialog from '@/components/Dialog/LoginDialog'
import AuthDialog from '@/components/Dialog/AuthDialog'
import BindMobileDialog from '@/components/Dialog/BindMobileDialog'
import PayGoodsDialog from '@/components/Dialog/PayGoodsDialog'
import OffAccountDialog from '@/components/Dialog/OffAccountDialog'
import BuyAccountInfoDialog from '@/components/Dialog/BuyAccountInfoDialog'
import FeedbackDialog from '@/components/Dialog/FeedbackDialog'
import PayFinishedDialog from '@/components/Dialog/PayFinishedDialog'
import ActSwitchDialog from '@/components/Dialog/ActSwitchDialog'
import BuyGroupVipDialog from '@/components/Dialog/BuyGroupVipDialog'
import BuyVipDialog from '@/components/Dialog/BuyVipDialog'
import UpdateRelatedProtocolsDialog from '@/components/Dialog/UpdateRelatedProtocolsDialog'

Vue.component('c-radio', Radio)
Vue.component('c-radio-group', RadioGroup)
Vue.component('DataLoader', DataLoader)
Vue.component('SearchInput', SearchInput)
Vue.component('RecGameItem', RecGameItem)
Vue.component('SearchGameItem', SearchGameItem)
Vue.component('Page', Page)
Vue.component('ListStatus', ListStatus)

Vue.use(Toast)
Vue.use(NormalDialog)
Vue.use(LoginDialog)
Vue.use(AuthDialog)
Vue.use(BindMobileDialog)
Vue.use(PayGoodsDialog)
Vue.use(OffAccountDialog)
Vue.use(BuyAccountInfoDialog)
Vue.use(FeedbackDialog)
Vue.use(PayFinishedDialog)
Vue.use(ActSwitchDialog)
Vue.use(BuyGroupVipDialog)
Vue.use(BuyVipDialog)
Vue.use(UpdateRelatedProtocolsDialog)
